export const initExpiry = () => {
    const element = document.querySelector('.js-cart-expiry');
    if (!element) {
        console.log('no js-cart-expiry')
        return
    }

    const server_expiry = element.dataset.expiry ? element.dataset.expiry : null ;
    const server_time = element.dataset.servertime ? element.dataset.servertime : null;

    const getAlertMessage = (locale) => {
        const messages = {
            'da-DK': 'Din kurv er udløbet',
            'de-DE': 'Ihr Warenkorb ist abgelaufen',
            'en-GB': 'Your cart has expired',
        };
        return messages[locale] || messages['da-DK'];
    };

    const expiry = server_expiry ? new Date(server_expiry * 1000) : null;
    console.log('Exp: ' + expiry);

    const now = server_time ? new Date(server_time * 1000) : null
    console.log('Now: ' + now);

    let expiryString = '0:00';

    if (!expiry || !now || isNaN(expiry.getTime()) || isNaN(now.getTime())) {
        console.log('im here')
        element.textContent = expiryString;
        return;
    }

    const intervalId = setInterval(() => {

        let remainingTime =  expiry.getTime() - now.getTime();
        let remainingTime_seconds = remainingTime / 1000;

        if (remainingTime > 0) {
            const minutes = Math.floor(remainingTime_seconds / 60);
            const seconds = ('0' + Math.floor(remainingTime_seconds % 60)).slice(-2);
            expiryString = `${minutes}:${seconds}`;
        } else {
            clearInterval(intervalId);
            const userLocale = document.documentElement.lang
            alert(getAlertMessage(userLocale));
            window.location.href = '/';
            return;
        }

        element.textContent = expiryString;
        now.setSeconds(now.getSeconds() + 1);

    }, 1000);
};





export const initCartSpinners = () => {
	const quantities = document.querySelectorAll('.js-alter-quantity');
	if (!quantities.length) return;

	quantities.forEach((field) => {
		const spinners = field.querySelectorAll('.js-cart-spinner');
		const input = field.querySelector('input');
		spinners.forEach((spinner) => spinner.addEventListener('click', () =>
			updateQuantity(input, spinner.dataset.spinnerChange)));
		input.addEventListener('change', () => submitQuantity(input));
	});
};

const updateQuantity = (field, value) => {
	field.value = Math.max(parseInt(field.value) + parseInt(value), 0);
	// Force a "change" event.
	const event = new Event('change');
	field.dispatchEvent(event);
	// Add a loading class to the table to block usage of controls while updating the cart.
	const table = document.querySelector('.js-cart-table');
	if (table) table.classList.add('js-loading');
};

const submitQuantity = (input) => {
	const endpoint = location.pathname;
	const id = input.dataset.orderLine;
	const quantity = +input.value;
	const removed = quantity <= 0;

	const url = removed ? `${endpoint}deleteQuantity/${id}/`
		: `${endpoint}updateQuantity/${id}/${quantity}/`;

	if (removed && 'gtag' in window) {
		// Track removing tickets from the cart with gtag.
		const data = input.dataset;
		const item = {
			id: data.itemDateId,
			name: data.itemName,
			category: data.itemCategory,
			quantity: 0,
			price: data.itemPrice
		};
		gtag('event', 'remove_from_cart', {'items': [item]});
	}

	fetch(url)
		.then((response) => response.text())
		.then(replaceCartHTML);
};

const replaceCartHTML = (html) => {
	const partialCartWrapper = document.querySelector('[data-ajax-wrapper]');
	partialCartWrapper.innerHTML = html;
	const callout = document.querySelector('.js-callout');

	if (callout) {
		setTimeout(() => callout.classList.add('js-fading'), 1000);
		setTimeout(() => callout.parentNode.removeChild(callout), 3000);
	}
	initCartSpinners();
	initExpiry();
};

